import { Component, OnInit } from '@angular/core';
import { PublisherService } from '../../core/services/publisher.service';
import { HttpService } from '../../core/services/http/http.service';
import { ParmedApiService } from '../../core/api/parmed-api.service';
import { SanitizerService } from '../../core/services/sanitizer.service';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CacheConstant} from '../../core/constants/app.constant';

@Component({
  selector: 'package-insert',
  templateUrl: './package-insert.component.html',
  styleUrls: ['./package-insert.component.css']
})
export class PackageInsertComponent implements OnInit {
  NDCNumber: string;
  trimmedNDC: string;
  isPackageNotFound: boolean = false;
  isValidNdcLength: boolean = false;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName = this.envProperties.theme;


  constructor(
    private api: ParmedApiService,
    private http: HttpService,
    private sanitizerService: SanitizerService,
    private cache: AppCacheService,
  ) { }

  ngOnInit() {
    // PublisherService.changeBannerHeader('Search for Package Inserts');
  }
  ndcSearchSubmit(){
      let ndc = this.trimDashes(this.NDCNumber);
      if(ndc.length !== 11) {
        // AppUtilService.message.error('NDC must be 11 characters long.');
        this.isValidNdcLength = true;
        this.isPackageNotFound = false;
        return;
      } else {
        this.validateNDC(ndc).subscribe((response: any) => {
          if (response && !response.hasError) {
            this.isPackageNotFound = false;
            this.isValidNdcLength = false;
            window.open('https://dailymed.nlm.nih.gov/dailymed/search.cfm?labeltype=all&query='+ this.NDCNumber, '_blank');
          } else {
            this.isPackageNotFound = true;
            this.isValidNdcLength = false;
          }
        });
      }
  }
  
  trimDashes(ndcNumber: string) {
    if (ndcNumber) {
      this.trimmedNDC = ndcNumber.replace(/-/g, '');
    }
    return this.trimmedNDC;
  }

  validateNDC(ndc: string){
   //let  ndcValue= "00904-5711-35"
   const url = this.sanitizerService.sanitizeUrl(this.api.Config.VALIDATE_NDC_URL + ndc)
   return this.http.get(url);
  }
}